import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.prod';

const baseUrl = environment.baseUrl;
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private httpClient: HttpClient) {}

  loginService(data: { email: string; password: string }) {
    const body = new HttpParams()
      .set('email', data.email)
      .set('password', data.password)
      .set('device','web');
    return this.httpClient.post(baseUrl+'login.php', body.toString());
  }
  registerService(data: { email: string; }) {
    const body = new HttpParams()
      .set('email', data.email);
    return this.httpClient.post(baseUrl +'register.php', body.toString());
  }

  getOtp(data) {
    console.log(data)
    var body = new HttpParams()
    .set('mobile', data);
    return this.httpClient.post(baseUrl+'get_otp.php', body);
  }

  validateOtp(data) {
    var body = new HttpParams()
      .set('mobile', data.mobile)
      .set('device', 'web')
      .set('otp', data.otp) ;
    return this.httpClient.post(baseUrl + 'validate_otp.php', body);
  }
  loginOtp(data) {
    var body = new HttpParams()
      .set('userid', data.userid)
      .set('device', 'web');
    return this.httpClient.post(baseUrl + 'login_otp.php', body);
  }
}
